module.exports = "#version 300 es\r\n\r\nin vec4 vs_Pos; // Non-instanced; each particle is the same quad drawn in a different place\r\nin vec4 vs_Col; // An instanced rendering attribute; each particle instance has a different color\r\nin vec2 vs_UV;\r\nin vec3 vs_Translate; // Another instance rendering attribute used to position each quad instance in the scene\r\n\r\nout vec2 fs_UV;\r\n\r\nvoid main()\r\n{\r\n    fs_UV = vs_UV;\r\n\tgl_Position = vs_Pos;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/debug-vert.glsl
// module id = 78
// module chunks = 0